import React, { useState, useEffect } from 'react';

const ExampleObituaries = () => {
  const [examples, setExamples] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load example obituaries data
    fetch('/example-obituaries.json')
      .then(res => res.json())
      .then(data => {
        setExamples(data.examples || []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading example obituaries:', err);
        setLoading(false);
      });
  }, []);

  const openLightbox = (pdfUrl) => {
    // Add ?view=inline parameter to force inline display
    const separator = pdfUrl.includes('?') ? '&' : '?';
    const absoluteUrl = pdfUrl.startsWith('http') 
      ? `${pdfUrl}${separator}view=inline` 
      : `${window.location.origin}${pdfUrl}${separator}view=inline`;
    setSelectedPdf(absoluteUrl);
  };

  const closeLightbox = () => {
    setSelectedPdf(null);
  };

  if (loading || examples.length === 0) {
    return null;
  }

  return (
    <>
      <div className="example-obituaries-section mt-5" id="examples">
        <div className="container">
          <div className="text-center mb-4">
            <h2 className="commercial-heading mb-3">See Our Work</h2>
            <p className="commercial-subheading">Professional obituaries for every life story</p>
          </div>

          <div className="row g-4 justify-content-center">
            {examples.map((example, index) => (
              <div key={index} className="col-lg-5 col-md-6">
                <div className="glass-card example-card" style={{ cursor: 'pointer', height: '100%' }} onClick={() => openLightbox(example.pdfUrl)}>
                  <div className="text-center mb-3">
                    <div className="example-icon mb-2">
                      <i className={`bi ${index === 0 ? 'bi-person-badge' : 'bi-person-hearts'}`} style={{ fontSize: '3rem', color: '#1e40af' }}></i>
                    </div>
                    <h3 className="example-name" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000000', marginBottom: '0.5rem' }}>
                      {example.name}
                    </h3>
                    <p className="example-age" style={{ fontSize: '1rem', color: '#666', marginBottom: '1rem' }}>
                      Age {example.age}
                    </p>
                  </div>
                  
                  <div className="example-preview" style={{ 
                    maxHeight: '200px', 
                    overflow: 'hidden',
                    marginBottom: '1rem',
                    padding: '1rem',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '12px',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}>
                    <p style={{ 
                      color: '#000000', 
                      fontSize: '0.9rem', 
                      lineHeight: '1.6',
                      display: '-webkit-box',
                      WebkitLineClamp: 6,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textAlign: 'left'
                    }}>
                      {example.obituaryText.split('\n\n')[0]}...
                    </p>
                  </div>

                  <button 
                    className="btn btn-outline-primary w-100"
                    onClick={(e) => { e.stopPropagation(); openLightbox(example.pdfUrl); }}
                    style={{ 
                      color: '#000000 !important', 
                      borderColor: '#1e40af',
                      backgroundColor: 'transparent'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#000000';
                      e.target.style.backgroundColor = 'rgba(30, 64, 175, 0.1)';
                      const icon = e.target.querySelector('i');
                      if (icon) icon.style.color = '#000000';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#000000';
                      e.target.style.backgroundColor = 'transparent';
                      const icon = e.target.querySelector('i');
                      if (icon) icon.style.color = '#000000';
                    }}
                  >
                    <i className="bi bi-file-earmark-pdf me-2" style={{ color: '#000000' }}></i>
                    <span style={{ color: '#000000' }}>View Full Obituary PDF</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* PDF Lightbox */}
      {selectedPdf && (
        <div 
          className="pdf-lightbox-overlay"
          onClick={closeLightbox}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
          }}
        >
          <div 
            className="pdf-lightbox-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              width: '100%',
              maxWidth: '900px',
              height: '90vh',
              backgroundColor: '#fff',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
            }}
          >
            <button
              onClick={closeLightbox}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'rgba(0, 0, 0, 0.7)',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                fontSize: '24px',
                cursor: 'pointer',
                zIndex: 10001,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.9)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'}
            >
              ×
            </button>
            
            <iframe
              src={selectedPdf}
              style={{
                width: '100%',
                height: '100%',
                border: 'none'
              }}
              title="Obituary PDF"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ExampleObituaries;

